var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  var color = props.fillColor || "#0F3951";
  var outlineColor = props.filled ? 'none' : color;
  var filledColor = props.filled ? color : 'none';
  delete props.filled;
  delete props.fillColor;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 21.54",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "down-arrow"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10762",
    "data-name": "Group 10762"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10761",
    "data-name": "Group 10761"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6305",
    "data-name": "Path 6305",
    d: "M19.23,13.85a.77.77,0,0,0-.77.77h0v4.61a.76.76,0,0,1-.76.77H2.31a.77.77,0,0,1-.77-.77h0V14.62a.77.77,0,0,0-1.54,0v4.61a2.31,2.31,0,0,0,2.31,2.31H17.69A2.31,2.31,0,0,0,20,19.23h0V14.62A.76.76,0,0,0,19.23,13.85Z",
    transform: "translate(0 0)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_10764",
    "data-name": "Group 10764"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10763",
    "data-name": "Group 10763"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6306",
    "data-name": "Path 6306",
    d: "M14.37,13.3a.77.77,0,0,0-1.07,0l-2.53,2.53V.77a.77.77,0,0,0-1.54,0h0V15.84L6.7,13.3a.77.77,0,0,0-1.09,1.09l3.85,3.84a.76.76,0,0,0,1.08,0h0l3.85-3.84a.76.76,0,0,0,0-1.09Z",
    transform: "translate(0 0)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.c07a6f3ec113371b14decdbe05ac429b.svg";
export { ForwardRef as ReactComponent };
ForwardRef.hasFilled = false;